var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 13.6667C1.87484 13.6667 1.48234 13.5033 1.15567 13.1767C0.829005 12.85 0.66595 12.4578 0.666505 12V2C0.666505 1.54167 0.829839 1.14917 1.15651 0.8225C1.48317 0.495833 1.87539 0.332778 2.33317 0.333333H15.6665C16.1248 0.333333 16.5173 0.496667 16.844 0.823333C17.1707 1.15 17.3337 1.54222 17.3332 2V12C17.3332 12.4583 17.1698 12.8508 16.8432 13.1775C16.5165 13.5042 16.1243 13.6672 15.6665 13.6667H2.33317ZM8.99984 7.83333L2.33317 3.66667V12H15.6665V3.66667L8.99984 7.83333ZM8.99984 6.16667L15.6665 2H2.33317L8.99984 6.16667ZM2.33317 3.66667V2V12V3.66667Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3729e28ccd3342af7468a64bc4a3cb39.svg";
export { ForwardRef as ReactComponent };